import http from "../utils/axios";

// 电子签章
// 判断是否需要电子签
export const getIsContract = data => {
  return http({
    url: "/api/authentication/getIsContract", // 接口
    method: "post",
    data: data
  });
};
// 去签署电子章
export const getContractFileUrl = data => {
  return http({
    url: "/api/authentication/getContractFileUrl", // 接口
    method: "post",
    data: data
  });
};
// 获取签署合同信息
export const getOrderContractInfo = data => {
  return http({
    url: "/api/authentication/getOrderContractInfo", // 接口
    method: "post",
    data: data
  });
};
// 锁定合同
export const getContractFile = data => {
  return http({
    url: "/api/authentication/getContractFile", // 接口
    method: "post",
    data: data
  });
};
// 获取电子签章列表
export const getAuthorizationAuditList = data => {
  return http({
    url: "/api/authentication/getAuthorizationAuditList", // 接口
    method: "post",
    data: data
  });
};

// 电子签认证
// 获取验证码
export const getUserPhoneCode = data => {
  return http({
    url: "/api/authentication/getUserPhoneCode", // 接口
    method: "post",
    data: data
  });
};
// 验证验证码是否正确
export const checkUserPhoneCode = data => {
  return http({
    url: "/api/authentication/checkUserPhoneCode", // 接口
    method: "post",
    data: data
  });
};

// 提交认证
export const setCertificationInfo = data => {
  return http({
    url: "/api/authentication/setCertificationInfo", // 接口
    method: "post",
    data: data
  });
};
// 获取电子签章数据
export const getCertificationInfo = data => {
  return http({
    url: "/api/authentication/getCertificationInfo", // 接口
    method: "post",
    data: data
  });
};
// 申请电子章
export const enterpriseCertification = data => {
  return http({
    url: "/api/authentication/enterpriseCertification", // 接口
    method: "post",
    data: data
  });
};
